import { useEffect, useState } from "react"
import { I_gridFilter, I_hub, I_model } from "./types"
import Apis from "./apis"

export const useGrid = (p:{currenthub:I_hub,apis:Apis})=>{
    const [grid, setGrid] = useState<I_model[]>()
    const [gridFilter, setGridFilter] = useState<I_gridFilter>({hubId: p.currenthub.id,pageSize:10,pageNumber:1,rowsLength:0,isActive:true,advanced: {}})
    const fetchGrid = async (filter:I_gridFilter):Promise<boolean> => {
        const res = await p.apis.grid(filter)
        if(res){
            setGridFilter({...filter,rowsLength:res.length})
            setGrid(res.rows);
            return true
        }
        return false
    }
    useEffect(()=>{
        fetchGrid(gridFilter)
    },[])
    const updateGrid = async (callback?:any)=>{
        setTimeout(()=>{
            fetchGrid(gridFilter)
            if(callback){callback()}
        },300) 
    }
    const resetGridFilter = () => {
        fetchGrid({ hubId: 0, advanced: {},pageSize:10,pageNumber:1,rowsLength:0 })
    }
    const changeGridFilter = (newGridFilter:I_gridFilter,byFetch?:boolean)=>{
        setGridFilter(newGridFilter);
        if(byFetch){fetchGrid(newGridFilter)}
    }
    return {grid,gridFilter,changeGridFilter,resetGridFilter,updateGrid}
}